import React from "react";
import { FavoriteCardsList } from "./FavoriteCardsList";
import "./Favorites.css";

export const Favorites = () => {
	return <FavoriteCardsList />;
};
